// MEMO: import this for IE11.
// MEMO: Swiper 5.4.5 works on IE11.
// import Swiper from "../../node_modules/swiper/js/swiper";

// import the latest version
import Swiper, { Navigation, Pagination, Autoplay } from "swiper";

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay]);

/*
 *
 * ----------------------------------------------- */
new Swiper(".swiper-simple", {
  observer: true,
  observeParents: true,
  slidesPerView: "auto",
  centeredSlides: true,
  spaceBetween: 13,
  initialSlide: 0,
  loop: true,
  speed: 1500,
  autoplay: {
    enabled: true,
    delay: 3000,
  },
  breakpoints: {
    767: {
      spaceBetween: 73,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    type: "bullets",
    renderBullet: function (index, className) {
      return (
        '<span class="' +
        className +
        '">' +
        "<span class='progress-bar'></span>" +
        "</span>"
      );
    },
  },
});

/*
 *
 * ----------------------------------------------- */
(function () {
  var slider = document.querySelector(
    ".swiper-container-nonstop-slide .swiper-slide"
  );

  if (slider === null) {
    return;
  }

  new Swiper(".swiper-container-nonstop-slide .swiper-container", {
    observer: true,
    observeParents: true,
    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 25,
    initialSlide: 2,
    loop: true,
    speed: 7500,
    allowTouchMove: false,
    autoplay: {
      enabled: true,
      delay: 1,
    },
    breakpoints: {
      767: {
        spaceBetween: 27,
      },

      320: {
        spaceBetween: 10,
      },
    },
  });
})();

/*
 *
 * ----------------------------------------------- */
new Swiper(".swiper-equipment", {
  slidesPerView: 2,
  spaceBetween: 25,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  breakpoints: {
    767: {
      spaceBetween: 25,
      slidesPerView: 2,
    },

    320: {
      spaceBetween: 10,
      slidesPerView: "auto",
    },
  },
});

/*
 *
 * ----------------------------------------------- */
$(".body-swiper").each(function (index, element) {
  new Swiper(".swiper-simple-campers-" + index, {
    observer: true,
    observeParents: true,
    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 13,
    initialSlide: 0,
    speed: 1500,
    loop: true,
    autoplay: {
      enabled: true,
      delay: 3000,
    },
    breakpoints: {
      767: {
        spaceBetween: 80,
      },
    },
    navigation: {
      nextEl: ".campers-next-" + index,
      prevEl: ".campers-prev-" + index,
    },
  });
});

/*
 *
 * ----------------------------------------------- */
new Swiper(".swiper-travel", {
  slidesPerView: 1,
  centeredSlides: true,

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  $(".season-modal").on("show.bs.modal", function () {
    console.log("aaa");
    setTimeout(function () {
      new Swiper(".swiper-season", {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        effect: "fade",
      });
    }, 500);
  });
});
